import React, { useState } from 'react';
import './MindMapViewer.css';

const MindMapViewer = ({ nodes, onClose }) => {
    const [zoom, setZoom] = useState(1);
    const [pan, setPan] = useState({ x: 0, y: 0 });
    const [isPanning, setIsPanning] = useState(false);
    const [panStart, setPanStart] = useState({ x: 0, y: 0 });

    const renderNode = (node, parent = null) => {
        return (
            <g key={node.id}>
                {/* Connection line to parent */}
                {parent && (
                    <line
                        x1={parent.x}
                        y1={parent.y}
                        x2={node.x}
                        y2={node.y}
                        stroke="#753bbd"
                        strokeWidth="2"
                    />
                )}

                {/* Node circle/rect */}
                <g transform={`translate(${node.x}, ${node.y})`}>
                    <foreignObject
                        x="-60"
                        y="-25"
                        width="120"
                        height="50"
                    >
                        <div className={`mind-node-viewer ${node.id === 'root' ? 'root-node-viewer' : ''}`}>
                            {node.text}
                        </div>
                    </foreignObject>
                </g>

                {/* Render children */}
                {node.children && node.children.map(child => renderNode(child, node))}
            </g>
        );
    };

    const handleExport = () => {
        const dataStr = JSON.stringify(nodes, null, 2);
        const dataBlob = new Blob([dataStr], { type: 'application/json' });
        const url = URL.createObjectURL(dataBlob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `mindmap-${new Date().toISOString().split('T')[0]}.json`;
        link.click();
        URL.revokeObjectURL(url);
    };

    const handleMouseDown = (e) => {
        setIsPanning(true);
        setPanStart({ x: e.clientX - pan.x, y: e.clientY - pan.y });
    };

    const handleMouseMove = (e) => {
        if (isPanning) {
            setPan({
                x: e.clientX - panStart.x,
                y: e.clientY - panStart.y
            });
        }
    };

    const handleMouseUp = () => {
        setIsPanning(false);
    };

    return (
        <div className="mindmap-viewer-modal-overlay" onClick={onClose}>
            <div className="mindmap-viewer-modal" onClick={e => e.stopPropagation()}>
                <div className="mindmap-viewer-modal-header">
                    <h3>🧠 Mind Map Preview</h3>
                    <div className="mindmap-viewer-modal-actions">
                        <button onClick={handleExport} className="mindmap-export-btn">
                            💾 Export JSON
                        </button>
                        <button onClick={onClose} className="mindmap-close-modal-btn">
                            ×
                        </button>
                    </div>
                </div>

                <div
                    className="mindmap-viewer-canvas-container"
                    onMouseDown={handleMouseDown}
                    onMouseMove={handleMouseMove}
                    onMouseUp={handleMouseUp}
                    onMouseLeave={handleMouseUp}
                    style={{ cursor: isPanning ? 'grabbing' : 'grab' }}
                >
                    <svg
                        width="100%"
                        height="500"
                        style={{
                            transform: `translate(${pan.x}px, ${pan.y}px) scale(${zoom})`,
                            transition: isPanning ? 'none' : 'transform 0.1s'
                        }}
                    >
                        {nodes && nodes.map(node => renderNode(node))}
                    </svg>
                </div>

                <div className="mindmap-viewer-zoom-controls">
                    <button onClick={() => setZoom(Math.min(zoom + 0.1, 2))}>🔍 +</button>
                    <span>{Math.round(zoom * 100)}%</span>
                    <button onClick={() => setZoom(Math.max(zoom - 0.1, 0.5))}>🔍 -</button>
                    <button onClick={() => { setZoom(1); setPan({ x: 0, y: 0 }); }}>Reset</button>
                </div>
            </div>
        </div>
    );
};

export default MindMapViewer;
